module.exports = __webpack_public_path__ + "img/water_based.0a328a7d.jpg";